<template>
	<div class="Editorial5">
		<div class="mt-5">
			<div class="container">
				<h1>{{ $t('navigationEditorial.editorial5.title') }}</h1>
				<div class="row align-items-center">
					<div class="py-5 col-9">
						<div class="mb-5">
							{{ $t('navigationEditorial.editorial5.content.absatz1') }}
						</div>
						<h4 class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz2') }}
						</h4>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz3') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz4') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz5') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz6') }}
						</div>
						<div class="mb-5">
							{{ $t('navigationEditorial.editorial5.content.absatz7') }}
						</div>
						<h4 class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz8') }}
						</h4>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz9') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz10') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz11') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz12') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz13') }}
						</div>
						<div class="mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz14') }}
						</div>
						<div class="Zitat mb-2">
							{{ $t('navigationEditorial.editorial5.content.absatz15') }}
						</div>
						<div class="Zitat mb-3">
							{{ $t('navigationEditorial.editorial5.content.absatz16') }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import editorialMixin from '@/views/editorial/editorialMixin.js'

export default {
	name: 'Editorial5',
	mixins: [editorialMixin]
}
</script>
